import * as React from "react";
import Button from "components/form/button";
import Dialog from "components/dialog/dialog";
import { formatMessage } from "lib/globalize-util";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import { DATATEST } from "constants/integration";

interface IProps {
    isOpen: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

export const ChangeWarehouseConfirmation: React.FC<IProps> = ({ isOpen = false, onConfirm, onClose }) => {
    const actions = React.useMemo(
        () => [
            <Button
                key="cancel"
                data-test={DATATEST.CATALOG.CHANGE_WAREHOUSE_CANCEL}
                style={styles.calcelButton}
                label={formatMessage("Cancel")}
                onClick={onClose}
            />,
            <Button
                key="yes"
                data-test={DATATEST.CATALOG.CHANGE_WAREHOUSE_SUBMIT}
                label={formatMessage("Change Warehouse")}
                onClick={onConfirm}
                primary={true}
            />,
        ],
        [onClose, onConfirm],
    );
    const title = React.useMemo(
        () => (
            <span style={styles.title}>
                <ErrorOutlineOutlinedIcon fontSize="large" color="error" style={styles.titleIcon} />
                <span style={styles.titleText}>{formatMessage("Change Warehouse?")}</span>
            </span>
        ),
        [],
    );
    return (
        <Dialog
            actions={actions}
            actionsContainerStyle={styles.actionsContainerStyle}
            contentStyle={styles.contentStyle}
            onRequestClose={onClose}
            open={isOpen}
            style={styles.container}
            title={title}
            closeButtonStyle={styles.closeButton}
        >
            <p style={styles.message}>
                {formatMessage(
                    "Changing the warehouse will hide products that are not available in the selected warehouse.",
                )}
            </p>
        </Dialog>
    );
};

const styles = {
    actionsContainerStyle: {
        display: "flex",
        justifyContent: "right",
    },
    contentStyle: {
        maxWidth: "600px",
    },
    container: {
        zIndex: 3000,
    },
    title: {
        lineHeight: "50px",
    },
    titleText: {
        marginLeft: "10px",
        verticalAlign: "middle",
    },
    titleIcon: {
        verticalAlign: "middle",
    },
    closeButton: {
        top: "10px",
        right: "10px",
    },
    calcelButton: {
        marginRight: "10px",
    },
    message: {
        padding: "16px 0 0 0",
    },
};
